import idLang from "../assets/lang/id.json";
import enLang from "../assets/lang/en.json";
import { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";

/** @typedef {typeof enLang} Lang */
/** @typedef {"ID" | "EN"} LangSelect */

/**
 * function to copy missing properties from source to target
 */
const copyMissingProperties = (source, target) => {
  for (const key in source) {
    if (!target.hasOwnProperty(key)) {
      target[key] = source[key];
    } else if (typeof source[key] === "object" && source[key] !== null && !Array.isArray(source[key])) {
      copyMissingProperties(source[key], target[key]);
    }
  }
  return target;
};

const useLang = () => {
  const lang = useSelector((state) => state.config.lang);
  const dispatch = useDispatch();

  /**
   * @type {Lang}
   */
  const langJSON = useMemo(() => {
    if (lang === "ID") {
      return copyMissingProperties(enLang, idLang);
    }
    return enLang;
  }, [lang]);

  /**
   * @param {LangSelect} val
   */
  const handleSetLang = (val) => dispatch.config.changeLang(val);

  return {
    mode: lang,
    lang: langJSON,
    setLang: handleSetLang,
  };
};

export default useLang;
